exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._8AUNlU46MaU9vF9FgyLmc{overflow:hidden;text-align:left;max-height:100%}._3vRemz8momwBhcTQ3wMTtn{width:100%;height:500px}@media screen and (max-width: 500px){._3vRemz8momwBhcTQ3wMTtn{height:300px;max-width:100%}}\n", ""]);

// Exports
exports.locals = {
	"Postcard": "_8AUNlU46MaU9vF9FgyLmc",
	"imagecells": "_3vRemz8momwBhcTQ3wMTtn"
};